/**
 * Created by ldang on 7/11/2017.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { CreatePlanComponent } from './components/create-plan/create-plan.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { ManageUsersComponent } from './components/manage-users/manage-users.component';
import { PlanningComponent } from './components/planning/planning.component';
import { UserManagementGuard } from './core/services/user-management.guard';
// import { WorkoutPlanComponent } from './components/workout-plan/workout-plan.component';
import { AuthGuard } from './services/auth.guard';
import { EmailSubdomainGuard } from './services/email-subdomain.guard';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard],
  },
  {
    path: 'planning',
    component: PlanningComponent,
    canActivate: [AuthGuard, EmailSubdomainGuard],
  },
  // {
  //   path: 'management',
  //   component: GroupManagementComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'create-group/:id',
  //   component: CreateGroupComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'workout-plan/:id',
  //   redirectTo: 'planning',
  //   component: WorkoutPlanComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'create-plan',
  //   redirectTo: 'planning',
  //   component: CreatePlanComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'create-plan/:id',
  //   redirectTo: 'planning',
  //   component: CreatePlanComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'login',
    component: LoginComponent,
  },
  // {
  //   path: 'explore',
  //   component: ExploreComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'explore/:id',
  //   component: GroupStatsComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'explore/:id/survey/:surveyId',
  //   component: GroupStatsComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'manage',
    component: ManageUsersComponent,
    canActivate: [AuthGuard, UserManagementGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
